/**
 * Shared dropzone styling constants for file upload components.
 * Used by FileUploader, ImageField, and other upload components.
 */

/** Base dropzone container styles */
export const dropzoneBaseStyles =
  "flex flex-col items-center justify-center gap-1 rounded-md border p-4 cursor-pointer w-full transition-all duration-100 hover:shadow-md";

/** Styles applied when dragging over the dropzone */
export const dropzoneDragActiveStyles = "border-dashed border-brand-600 bg-brand-100";

/** Styles for the upload icon */
export const dropzoneIconStyles = "mx-auto text-brand-700";

/** Styles for the hint text (accepted file types) */
export const dropzoneHintStyles = "text-brand-700";

/** Styles applied when dropzone is disabled */
export const dropzoneDisabledStyles = "cursor-not-allowed opacity-50";

/** Error border style */
export const dropzoneErrorStyles = "border-error-600";
